import api from '@/configs/GlobalRequestHandler.js';

export default {
  createPrize:(prizeBody, raffleId) => {
    return api.postRequestWithBody(`/campaigns_awards/${raffleId}`, prizeBody)
  },
  deletePrize:(prizeId) => {
    return api.deleteRequest(`/campaigns_awards/${prizeId}`)
  },
}